$(document).on('click', '#submit_password', async function () {
    const password    = $('#location_password').val();
    const location_id = $(this).attr('location-id');
    const authResponse = await authoriseLocation(location_id, password);
    console.log(authResponse);
    if(authResponse.success) {
        notify('Password accepted', 'green');
        $('#password-modal').addClass('hidden');
        $(`button.show_calendar[data-location-id="${location_id}"]`).click();
    } else {
        notify('Incorrect Password', 'red');
        return false
    }
});

const authoriseLocation = async (location_id, password) => {
    try {
        const response = await fetch(`/api/location/authorise`, {
            method:  'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            body:    JSON.stringify({
                json:        true,
                location_id: location_id,
                password:    password,
            })
        });
        return await response.json()
    } catch (error) {
        console.log(error)
    }
}
